// custom typefaces (latin subset only, so that webpack doesn't inline
// dozens of small subset files in every page)
import '@fontsource/montserrat/latin-400.css'
import '@fontsource/montserrat/latin-900.css'
import '@fontsource/merriweather/latin-400.css'
import '@fontsource/merriweather/latin-400-italic.css'
import '@fontsource/merriweather/latin-700.css'
import '@fontsource/merriweather/latin-700-italic.css'
import '@fontsource/merriweather/latin-900.css'
import '@fontsource/merriweather/latin-900-italic.css'

import 'katex/dist/katex.min.css'

import { wrapRootElement as wrap } from './wrap-root-element'

export const wrapRootElement = wrap
